import React from 'react';
import classNames from 'classnames';

const AuthenticationStructure = ({
    children,
    sectionClassName = 'eds-l-mar-vert-14',
    wrapperClassName,
}) => {
    const gridClasses =
        wrapperClassName ||
        classNames(
            'eds-g-cell',
            'eds-g-cell-10-12 eds-g-offset-1-12',
            'eds-g-cell-sm-8-12 eds-g-offset-sm-2-12',
            'eds-g-cell-sw-6-12 eds-g-offset-sw-3-12',
            'eds-g-cell-md-4-12 eds-g-offset-md-4-12',
            'eds-g-cell--has-overflow',
        );

    return (
        <div className={sectionClassName}>
            <div className="eds-g-group">
                <div className={gridClasses}>{children}</div>
            </div>
        </div>
    );
};

export default AuthenticationStructure;
